import store from "../../store";
import { showHideLoader } from "../../store/Loader/actions";
import history from "../../routes/History";
import { showHideSnackbar } from "../../store/Snackbar/actions";
import { loginResponse } from "../../store/Auth/actions";
import { ROUTE_PATHS } from "../../utils/PathsNames";

const storeToken = (token) => {
  const raw = localStorage.getItem("admin");
  if (raw) {
    const obj = JSON.parse(raw);
    obj.auth_token = token;
    localStorage.setItem("admin", JSON.stringify(obj));
  }
};

export const isHandlerEnabled = (config = {}) => {
  return Object.prototype.hasOwnProperty.call(
    config,
    "handlerEnabled"
  ) && !config.handlerEnabled
    ? false
    : true;
};

const FALLBACK_ERROR_MESSAGE =
  "Something went wrong. Please try again.";

export const extractErrorMessage = (error) => {
  const data = error?.response?.data;
  if (data && typeof data === "object") {
    if (Array.isArray(data.errors) && data.errors.length > 0) {
      return data.errors.join(", ");
    }
    if (typeof data.error === "string" && data.error.trim() !== "") {
      return data.error;
    }
    if (
      typeof data.message === "string" &&
      data.message.trim() !== ""
    ) {
      return data.message;
    }
  }
  if (typeof data === "string" && data.trim() !== "") {
    return data;
  }
  return FALLBACK_ERROR_MESSAGE;
};

export const requestHandler = (request) => {
  if (isHandlerEnabled(request)) {
    store.dispatch(showHideLoader(true));
    const adminData =
      JSON.parse(localStorage.getItem("admin")) ||
      JSON.parse(sessionStorage.getItem("admin")) ||
      JSON.parse(localStorage.getItem("tempAdmin"));
    const token = adminData?.auth_token;
    if (token) {
      request.headers["Authorization"] = `Bearer ${token}`;
    }
  }
  return request;
};

export const successHandler = (response) => {
  const state = store?.getState();
  if (isHandlerEnabled(response)) {
    response.lang = state.locale.lang;
    store.dispatch(showHideLoader(false));
    // return response;
  }

  const newToken = response.headers["x-new-access-token"];

  if (newToken) {
    storeToken(newToken); // update wherever you keep the JWT
  }
  return response;
};

export const errorHandler = (error) => {
  if (
    error.response?.status === 401 ||
    error.response?.status === 403
  ) {
    store.dispatch(loginResponse({}));

    history.push(ROUTE_PATHS["login"]);
  }

  if (isHandlerEnabled(error.config)) {
    store.dispatch(showHideLoader(false));
    store.dispatch(
      showHideSnackbar({
        isOpen: true,
        type: "error",
        message: extractErrorMessage(error)
      })
    );
  }
  return Promise.reject({ ...error });
};
